import apiConfiguredService from '../api-configured.service';

const endpointPrefix = '/auth';

const authApi = {

  mswLogin(username:string , loginPassword:string) {
    const reqEndpoint = endpointPrefix;
    const dataToSubmit = { user : username , password : loginPassword };
    return apiConfiguredService
    .patch(reqEndpoint , dataToSubmit); // placeholder for patch/post
  },
};

export default authApi;
